import React, { useState, useEffect } from 'react';
import { Typography, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Button, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import axios from 'axios';
import { connect } from 'redux-zero/react';
import actions from '../../actions';
import moment from 'moment';
import PeriodSelector from './PeriodSelector';
import { formatMoney } from '../../utils';

const useStyles = makeStyles(theme => ({
    topBar: {
        marginBottom: 10
    },
    topBarLeftControl: {
        marginLeft: 10
    },
    topBarCheckBox: {
        marginLeft: 10,
        marginTop: -2,
        verticalAlign: 'top'
    },
    topBarControl: {
        float: 'right',
        marginLeft: 10
    }
}));

// Year label for a report period, the year in which it ends
function formatYear(endDate) {
    return String(moment(endDate).year());
}

const mapToProps = ({ selectedSociety, currentPeriod }) => ({ selectedSociety, currentPeriod });

function BalanceSheetReport({ selectedSociety, currentPeriod }) {
    const classes = useStyles();

    const [report, setReport] = useState({ items: [] });
    const [fromDate, setFromDate] = useState(currentPeriod.startDate);
    const [toDate, setToDate] = useState(currentPeriod.endDate);
    const [showPreviousYear, setShowPreviousYear] = useState(true);

    useEffect(() => {
        if (moment(fromDate).year() < 1000 || moment(toDate).year() < 1000) return;
        
        axios.get('/report/balancesheet/' + moment(fromDate).format('YYYY-MM-DD') + '/' + moment(toDate).format('YYYY-MM-DD'),
            { params: { showPreviousYear }, headers: { 'X-SocietyId': selectedSociety } })
            .then(response => {
                setReport(response.data);
            });
    }, [selectedSociety, fromDate, toDate, showPreviousYear]);

    function downloadPdf() {
        axios.get('/report/pdf/balancesheet/' + moment(fromDate).format('YYYY-MM-DD') + '/' + moment(toDate).format('YYYY-MM-DD'),
            { params: { showPreviousYear }, headers: { 'X-SocietyId': selectedSociety }, responseType: 'arraybuffer' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                window.open(window.URL.createObjectURL(blob));
            });
    }

    const year = report.startDate ? formatYear(report.endDate) : 'Amount';
    const previousYear = report.previousEndDate ? formatYear(report.previousEndDate) : null;
    const columnsPerSide = previousYear ? 3 : 2;

    return (
        <>
            <Typography variant="h5">Balance Sheet</Typography>
            <div className={classes.topBar}>
                <FormControlLabel label="Show previous year" className={classes.topBarCheckBox}
                    control={<Checkbox checked={showPreviousYear}
                        onChange={() => { setShowPreviousYear(!showPreviousYear) }} />} />
                <PeriodSelector className={classes.topBarLeftControl} fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} />
                <Button className={classes.topBarControl} onClick={downloadPdf} variant="contained" size="small" color="primary">PDF</Button>
            </div>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><h2>Liabilities</h2></TableCell>
                            <TableCell colSpan={columnsPerSide - 1}></TableCell>
                            <TableCell><h2>Assets</h2></TableCell>
                            <TableCell colSpan={columnsPerSide - 1}></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                            {previousYear && <TableCell align="right">{previousYear}</TableCell>}
                            <TableCell align="right">{year}</TableCell>
                            <TableCell></TableCell>
                            {previousYear && <TableCell align="right">{previousYear}</TableCell>}
                            <TableCell align="right">{year}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {report.items.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell align={item.isTotal1 && !item.isGroup1 ? 'right' : 'left'}>{item.isGroup1 || item.isTotal1 ? (<b>{item.name1}</b>) : item.name1}&nbsp;</TableCell>
                                {previousYear && <TableCell align="right">{item.isTotal1 ? (<b>{formatMoney(item.previousClosingBalance1)}</b>) : formatMoney(item.previousClosingBalance1)}</TableCell>}
                                <TableCell align="right">{item.isTotal1 ? (<b>{formatMoney(item.closingBalance1)}</b>) : formatMoney(item.closingBalance1)}</TableCell>
                                <TableCell align={item.isTotal2 && !item.isGroup2 ? 'right' : 'left'}>{item.isGroup2 || item.isTotal2 ? (<b>{item.name2}</b>) : item.name2}&nbsp;</TableCell>
                                {previousYear && <TableCell align="right">{item.isTotal2 ? (<b>{formatMoney(item.previousClosingBalance2)}</b>) : formatMoney(item.previousClosingBalance2)}</TableCell>}
                                <TableCell align="right">{item.isTotal2 ? (<b>{formatMoney(item.closingBalance2)}</b>) : formatMoney(item.closingBalance2)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

export default connect(mapToProps, actions)(BalanceSheetReport);